import React from 'react';
import ErrorBoundary from '@/common/components/ErrorBoundary';

import RaffleButton from './components/RaffleButton';

export default () => (
    <ErrorBoundary>
        <RaffleButton />
    </ErrorBoundary>
);
